import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalStateService {
  IdleTimeOut = 30;
  private _isPreviewPortal = false;
  private _isAllowedDocViewDownload = false;
  private _DashboardInvestor;

  private _filedownloadviewer = new Subject();
  filedownloadviewer$ = this._filedownloadviewer.asObservable();

  get isPreviewPortal(): boolean {
    return this._isPreviewPortal;
  }

  set isPreviewPortal(value: boolean) {
    this._isPreviewPortal = value;
  }

  get isAllowedDocViewDownload(): boolean {
    return this._isAllowedDocViewDownload;
  }

  set isAllowedDocViewDownload(value: boolean) {
    this._isAllowedDocViewDownload = value;
  }
  
  get DashboardInvestor(): any {
    return this._DashboardInvestor;
  }

  set DashboardInvestor(value: any) {
    this._DashboardInvestor = value;
  }

  broadcastFileDownloadViewer(data: any): void {
    this._filedownloadviewer.next(data);
  }
  
}